import "../../../../assets/scss/components/sections/home/pricing.scss";
import { Container, Image } from "react-bootstrap";

import data from "./pricing_data.json";
import check from "../../../../assets/images/home/pricingCheck.svg";
import { useState } from "react";
import Btn from "../../../templates/button";
import shape1 from "../../../../assets/images/home/pricing-shape.svg";

const Pricing = () => {
  const [activePlan, setActivePlan] = useState("Free");
  const [isYearly, setIsYearly] = useState(data.pricing.map(() => true));

  const handleToggle = (index) => {
    setIsYearly((prevState) =>
      prevState.map((value, i) => (i === index ? !value : value))
    );
  };

  return (
    <div className="pricing-section" id="pricing">
      <Container>
        <div className="pricing">
          <div className="heading">
            <h1 className="heading-1">Pricing Plans</h1>
            <p className="paragraph-small-regular">
              Find the perfect plan that fits your job search
            </p>
          </div>
          <div className="pricing-content d-none d-md-flex">
            {data.pricing.map((d, i) => (
              <div className="pricing-box" key={i}>
                <div className="box-heading text-center">
                  <h4 className="heading-4">{d.planName}</h4>
                  <p className="paragraph-small-regular">{d.planType}</p>
                </div>
                <div className="pricing-buttons">
                  {d.hasToggle && (
                    <div className="toggle">
                      <button
                        className={`toggle-btn ${isYearly[i] ? "" : "active"}`}
                        onClick={() => handleToggle(i)}
                      >
                        Monthly
                      </button>
                      <button
                        className={`toggle-btn ${isYearly[i] ? "active" : ""}`}
                        onClick={() => handleToggle(i)}
                      >
                        Yearly
                      </button>
                    </div>
                  )}
                </div>
                <div className="plan-features">
                  {d.featuresList.map((feature, j) => (
                    <div className="plan-features-item" key={j}>
                      <div className="check">
                        <div className="icon">
                          <Image src={check} />
                        </div>
                      </div>
                      <p className="paragraph-small">{feature}</p>
                    </div>
                  ))}
                </div>
                <h2 className="plan-price text-center">
                  {d.planDurationMonthly ? (
                    isYearly[i] ? (
                      <>
                        {d.planOriginalYearlyPrice && (
                          <span className="original-price">
                            {d.planOriginalYearlyPrice}
                          </span>
                        )}
                        <span className="current-price">
                          {d.planYearlyPrice}
                          <span>/month</span>
                        </span>
                      </>
                    ) : (
                      <>
                        {d.planOriginalPrice && (
                          <span className="original-price">
                            {d.planOriginalPrice}
                          </span>
                        )}
                        <span className="current-price">
                          {d.planPrice}
                          <span>/month</span>
                        </span>
                      </>
                    )
                  ) : (
                    <span className="d-flex align-items-center">
                      {d.hasDiscount && (
                        <span className="original-price">
                          {d.planOriginalPrice}
                        </span>
                      )}
                      <span className="current-price">{d.planPrice}</span>
                    </span>
                  )}
                </h2>
                <Btn
                  text="Get Started"
                  class="btn-secondary"
                  handle={() => {
                    window.location.href =
                      process.env.REACT_APP_APP_REGISTER_URL;
                  }}
                />
                {d.popular && (
                  <h6 className="heading-6 popular">Most Popular</h6>
                )}
              </div>
            ))}
          </div>

          <div className="pricing-content-mobile d-flex d-md-none flex-column">
            {data.pricing.map((d, i) => (
              <div className="pricing-box" key={i}>
                <div className="box-heading text-center">
                  <h4 className="heading-4">{d.planName}</h4>
                  <p className="paragraph-small-regular">{d.planType}</p>
                </div>
                {d.popular && (
                  <h6 className="heading-6 popular">Most Popular</h6>
                )}
                <div className="pricing-buttons">
                  {d.hasToggle && (
                    <div className="toggle">
                      <button
                        className={`toggle-btn ${isYearly[i] ? "" : "active"
                          }`}
                        onClick={() => handleToggle(i)}
                      >
                        Monthly
                      </button>
                      <button
                        className={`toggle-btn ${isYearly[i] ? "active" : ""
                          }`}
                        onClick={() => handleToggle(i)}
                      >
                        Yearly
                      </button>
                    </div>
                  )}
                </div>
                <div className="plan-features">
                  {d.featuresList.map((feature, j) => (
                    <div className="plan-features-item" key={j}>
                      <div className="check">
                        <div className="icon">
                          <Image src={check} alt="Check Icon" />
                        </div>
                      </div>
                      <p className="paragraph-small">{feature}</p>
                    </div>
                  ))}
                </div>
                <h2 className="plan-price text-center">
                  {d.planDurationMonthly ? (
                    isYearly[i] ? (
                      <>
                        {d.planOriginalYearlyPrice && (
                          <span className="original-price">
                            {d.planOriginalYearlyPrice}
                          </span>
                        )}
                        <span className="current-price">
                          {d.planYearlyPrice}
                          <span>/month</span>
                        </span>
                      </>
                    ) : (
                      <>
                        {d.planOriginalPrice && (
                          <span className="original-price">
                            {d.planOriginalPrice}
                          </span>
                        )}
                        <span className="current-price">
                          {d.planPrice}
                          <span>/month</span>
                        </span>
                      </>
                    )
                  ) : (
                    <span className="d-flex align-items-center">
                      {d.hasDiscount && (
                        <span className="original-price">
                          {d.planOriginalPrice}
                        </span>
                      )}
                      <span className="current-price">{d.planPrice}</span>
                    </span>
                  )}
                </h2>
                <Btn
                  text="Get Started"
                  class="btn-secondary"
                  handle={() => {
                    window.location.href =
                      process.env.REACT_APP_APP_REGISTER_URL;
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </Container>
      <div className="shape-1 shape">
        <Image src={shape1} />
      </div>
    </div>
  );
};

export default Pricing;
